/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/**
 * Mapping of MIME type to extension.
 */
export default {
	'3d/vnd.adobe.dn+dcx': {
		ext: 'dn',
	},
	'3d/vnd.adobe.asd+dcx': {
		ext: 'dn',
	},
	'3d/vnd.adobe.3d+dcx': {
		ext: '3dmodel',
	},
	'application/vnd.apple.keynote.13': {
		ext: 'key',
	},
	'application/bmp': {
		ext: 'bmp',
	},
	'application/x-bmp': {
		ext: 'bmp',
	},
	'application/x-win-bmp': {
		ext: 'bmp',
	},
	'application/illustrator': {
		ext: 'ai',
	},
	'application/indesign': {
		ext: 'indd',
	},
	'application/javascript': {
		ext: 'js',
	},
	'application/macbinary': {
		ext: 'bin',
	},
	'application/msword': {
		ext: 'docx',
	},
	'document/vnd.adobe.psxc.mix+dcx': {
		ext: 'psx mix',
	},
	'document/vnd.adobe.psxc.edit+dcx': {
		ext: 'psx edit',
	},
	'document/vnd.adobe.psxc.fix+dcx': {
		ext: 'psx fix',
	},
	'document/vnd.adobe.psxc.collage+dcx': {
		ext: 'psx collage',
	},
	'application/photoshop': {
		ext: 'psd',
	},
	'application/psd': {
		ext: 'psd',
	},
	'application/vnd.adobe.ase': {
		ext: 'ase',
	},
	'application/vnd.adobe.clip.project+dcx': {
		ext: 'clip project',
	},
	'application/vnd.adobe.clsproject+dcx': {
		ext: 'cls project',
	},
	'application/vnd.adobe.cng+dcx': {
		ext: 'asd',
	},
	'application/vnd.adobe.collage': {
		ext: 'Creative File',
	},
	'application/vnd.adobe.directory+json': {
		ext: 'Folder',
	},
	'application/vnd.adobe.photoshop': {
		ext: 'psd',
	},
	'application/photoshop.large': {
		ext: 'psd',
	},
	'application/vnd.adobe.indesign-idms': {
		ext: 'idms',
	},
	'application/vnd.adobe.muse-collection': {
		ext: 'muse',
	},
	'application/vnd.adobe.charts+zip': {
		ext: 'zip',
	},
	'application/vnd.adobe.element.agc+json': {
		ext: 'Component',
	},
	'application/vnd.adobe.element.animation+dcx': {
		ext: 'Animation',
	},
	'application/vnd.adobe.element.brush+dcx': {
		ext: 'Brush',
	},
	'application/vnd.adobe.element.xbrush+dcx': {
		ext: 'Brush',
	},
	'application/vnd.adobe.element.capsule+dcx': {
		ext: 'Capsule',
	},
	'application/vnd.adobe.element.characterstyle+dcx': {
		ext: 'Character Style',
	},
	'application/vnd.adobe.element.chart+dcx': {
		ext: 'Chart',
	},
	'application/vnd.adobe.element.colortheme+dcx': {
		ext: 'Color Theme',
	},
	'application/vnd.adobe.element.color+dcx': {
		ext: 'Color',
	},
	'application/vnd.adobe.element.component+dcx': {
		ext: 'Component',
	},
	'application/vnd.adobe.element.graphic+dcx': {
		ext: 'Motion Graphic Template',
	},
	'application/vnd.adobe.element.gradient+dcx': {
		ext: 'Gradient',
	},
	'application/vnd.adobe.element.image+dcx': {
		ext: 'Graphic',
	},
	'application/vnd.adobe.element.layerstyle+dcx': {
		ext: 'Layer Style',
	},
	'application/vnd.adobe.element.light+dcx': {
		ext: 'Light',
	},
	'application/vnd.adobe.element.look+dcx': {
		ext: 'Look',
	},
	'application/vnd.adobe.element.material+dcx': {
		ext: 'Material',
	},
	'application/vnd.adobe.element.3d+dcx': {
		ext: 'Model',
	},
	'application/vnd.adobe.element.paragraphstyle+dcx': {
		ext: 'Paragraph Style',
	},
	'application/vnd.adobe.element.pattern+dcx': {
		ext: 'Pattern',
	},
	'application/vnd.adobe.element.template+dcx': {
		ext: 'Template',
	},
	'application/vnd.adobe.element.text+dcx': {
		ext: 'Text',
	},
	'application/vnd.adobe.element.video+dcx': {
		ext: 'Video',
	},
	'application/vnd.adobe.library+dcx': {
		ext: 'library',
	},
	'application/vnd.adobe.comp.project+dcx': {
		ext: 'composition project',
	},
	'application/vnd.adobe.draw.project+dcx': {
		ext: 'draw project',
	},
	'application/vnd.adobe.file+json': {
		ext: 'indd',
	},
	'application/vnd.adobe.idea': {
		ext: 'idea',
	},
	'application/json': {
		ext: 'json',
	},
	'application/vnd.adobe.ideas': {
		ext: 'idea',
	},
	'application/vnd.adobe.illustrator': {
		ext: 'ai',
	},
	'application/vnd.adobe.layup.project+dcx': {
		ext: 'layup project',
	},
	'application/vnd.adobe.line.sketchbook+dcx': {
		ext: 'line project',
	},
	'application/vnd.adobe.photoshop-fix.composition+dcx': {
		ext: 'fix project',
	},
	'application/vnd.adobe.photoshop-mix.composition+dcx': {
		ext: 'photo composition',
	},
	'application/vnd.adobe.psremix': {
		ext: 'psdx',
	},
	'application/vnd.adobe.proto': {
		ext: 'proto',
	},
	'application/vnd.adobe.proto.zip': {
		ext: 'proto',
	},
	'application/vnd.adobe.pstouch': {
		ext: 'psdx',
	},
	'application/vnd.adobe.real': {
		ext: 'real',
	},
	'application/vnd.adobe.real+dcx': {
		ext: 'real',
	},
	'application/vnd.adobe.sketch.project+dcx': {
		ext: 'sketch project',
	},
	'application/vnd.adobe.sparkler.project+dcx': {
		ext: 'xd',
	},
	'application/vnd.adobe.sparkler.project+dcxucf': {
		ext: 'xd',
	},
	'application/vnd.adobe.xd.cloudproject+dcx': {
		ext: 'xdc',
	},
	'document/vnd.adobe.cpsd+dcx': {
		ext: 'psdc',
	},
	'document/vnd.adobe.gemini+dcx': {
		ext: 'psdc',
	},
	'document/vnd.adobe.illustrator+dcx': {
		ext: 'aic',
	},
	'application/vnd.adobe.uxdesign.designspec+dcx': {
		ext: 'Design Specs',
	},
	'application/vnd.adobe.uxdesign.prototype+dcx': {
		ext: 'Prototype',
	},
	'application/vnd.adobe.xd.sharedartifact+dcx': {
		ext: 'xdc',
		specializations: {
			ext: {
				assetType: {
					designSpec: 'Design Specs',
					prototype: 'Prototype',
				},
			},
		},
	},
	'application/x-sharedcloud-mount+json': {
		ext: 'Shared Folder',
	},
	'application/x-sharedcloud-collection+json': {
		ext: 'Folder',
		specializations: {
			ext: {
				assetType: {
					folder: 'Folder',
					space: 'Space',
				},
			},
		},
	},
	'model/gltf-binary': {
		ext: '3D Scene',
	},
	'application/vnd.openxmlformats-officedocument.presentationml.presentation': {
		ext: 'pptx',
	},
	'application/vnd.openxmlformats-officedocument.presentationml.slideshow': {
		ext: 'ppsx',
	},
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
		ext: 'xlsx',
	},
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
		ext: 'docx',
	},
	'application/vnd.ms-excel': {
		ext: 'xls',
	},
	'application/x-adobe-libraries-psdt': {
		ext: 'psdt',
	},
	'application/x-font-ttf': {
		ext: 'ttf',
	},
	'application/x-httpd-php': {
		ext: 'php',
	},
	'application/x-javascript': {
		ext: 'js',
	},
	'application/x-photoshop': {
		ext: 'psd',
	},
	'application/x-rar-compressed': {
		ext: 'rar',
	},
	'application/x-shockwave-flash': {
		ext: 'swf',
	},
	'application/xhtml+xml': {
		ext: 'xml',
	},
	'application/xml': {
		ext: 'xml',
	},
	'application/zip': {
		ext: 'zip',
	},
	'audio/mpeg': {
		ext: 'mp3',
	},
	'audio/mpg': {
		ext: 'mp3',
	},
	'audio/x-wav': {
		ext: 'wav',
	},
	folder: {
		ext: 'Folder',
	},
	sharedFolder: {
		ext: 'Shared Folder',
	},
	'image/bmp': {
		ext: 'bmp',
	},
	'image/dng': {
		ext: 'dng',
	},
	'image/gif': {
		ext: 'gif',
	},
	'image/jpeg': {
		ext: 'jpeg',
	},
	'image/jpg': {
		ext: 'jpg',
	},
	'image/jp2': {
		ext: 'jp2',
	},
	'image/ms-bmp': {
		ext: 'bmp',
	},
	'image/photoshop': {
		ext: 'psd',
	},
	'image/pjpeg': {
		ext: 'pjpeg',
	},
	'image/png': {
		ext: 'png',
	},
	'image/psd': {
		ext: 'psd',
	},
	'image/raw': {
		ext: 'raw',
	},
	'image/svg': {
		ext: 'svg',
	},
	'image/svg+xml': {
		ext: 'svg',
	},
	'image/tiff': {
		ext: 'tiff',
	},
	'image/vnd.adobe.cls+dcx': {
		ext: 'fix',
	},
	'image/vnd.adobe.photoshop': {
		ext: 'psd',
	},
	'application/vnd.ms-powerpoint': {
		ext: 'ppt',
	},
	'audio/x-aiff': {
		ext: 'aif',
	},
	'application/vnd.groove-tool-template': {
		ext: 'Template',
	},
	'application/msexcel': {
		ext: 'xls',
	},
	'application/vnd.iccprofile': {
		ext: 'icc',
	},
	'application/vnd.adobe.aftereffects.project': {
		ext: 'aep',
	},
	'image/vnd.adobe.shape+dcx': {
		ext: 'svg',
	},
	'image/vnd.adobe.shape+svg': {
		ext: 'svg',
	},
	'image/x-adobe-dng': {
		ext: 'dng',
	},
	'image/x-bitbmp': {
		ext: 'bmp',
	},
	'image/x-bmp': {
		ext: 'bmp',
	},
	'image/x-dcraw': {
		ext: 'raw',
	},
	'image/x-eps': {
		ext: 'eps',
	},
	'image/x-ms-bmp': {
		ext: 'bmp',
	},
	'image/x-photoshop': {
		ext: 'psd',
	},
	'image/x-png': {
		ext: 'png',
	},
	'image/x-win-bitbmp': {
		ext: 'bmp',
	},
	'image/x-windows-bmp': {
		ext: 'bmp',
	},
	'image/x-xbitbmp': {
		ext: 'bmp',
	},
	'image/heif': {
		ext: 'heif',
	},
	'image/heic': {
		ext: 'heic',
	},
	'model/vnd.pixar.usd.usdz': {
		ext: 'usdz',
	},
	'model/vnd.pixar.usd': {
		ext: 'usdz',
	},
	'model/usd': {
		ext: 'usdz',
	},
	'model/xra': {
		ext: 'xra',
	},
	'model/vnd.adobe.dn+dcx': {
		ext: 'dn',
	},
	'text/css': {
		ext: 'css',
	},
	'text/html': {
		ext: 'html',
	},
	'text/javascript': {
		ext: 'js',
	},
	'text/plain': {
		ext: 'txt',
	},
	'text/csv': {
		ext: 'csv',
	},
	'text/rtf': {
		ext: 'rtf',
	},
	'text/vnd.adobe.textfragment+dcx': {
		ext: 'textfragment',
	},
	'video/quicktime': {
		ext: 'mov',
	},
	'video/mp4': {
		ext: 'mp4',
	},
	'video/mpeg': {
		ext: 'mpeg',
	},
	'video/mpg': {
		ext: 'mpeg',
	},
	'image/vnd.adobe.photoshop.template': {
		ext: 'psdt',
	},
	'video/x-f4v': {
		ext: 'f4v',
	},
	'video/x-flv': {
		ext: 'flv',
	},
	'video/x-m4v': {
		ext: 'm4v',
	},
	'video/x-msvideo': {
		ext: 'avi',
	},
	'video/x-ms-asf': {
		ext: 'asf',
	},
	'video/x-ms-wmv': {
		ext: 'wmv',
	},
	'video/x-photoshop': {
		ext: 'psd',
	},
	'video/x-quicktime': {
		ext: 'mov',
	},
	'video/3gpp': {
		ext: '3gp',
	},
	'video/x-matroska': {
		ext: 'mkv',
	},
	'application/vnd.adobe.theo.document+dcx': {
		ext: 'Post',
	},
	'application/vnd.adobe.ginger.project+dcx': {
		ext: 'Video',
	},
	'application/vnd.adobe.luca.document+dcx': {
		ext: 'Page',
	},
	'application/vnd.adobe.weblink+dcx': {
		ext: 'Web link',
	},
	'application/vnd.adobe.hz.canvas+dcx': {
		ext: 'Canvas',
	},
	'application/vnd.adobe.hz+dcx': {
		ext: 'Canvas',
	},
	'application/vnd.ms-excel.sheet.macroenabled.12': {
		ext: 'xlsx',
	},
	'application/vnd.ms-outlook': {
		ext: 'outlook',
	},
	'application/x-msdownload': {
		ext: 'msexecutable',
	},
	'application/postscript': {
		ext: 'pdf',
	},
	'application/vnd.oasis.opendocument.text': {
		ext: 'txt',
	},
	'application/x-zip-compressed': {
		ext: 'zip',
	},
	'application/epub+zip': {
		ext: 'epub',
	},
	'application/pdf': {
		ext: 'pdf',
	},
	unknown: {
		ext: 'app.type.unknown',
	},
	unsupported: {
		ext: 'unsupported',
	},
};
